import { RegistrationError } from './errors';
export class TrainSDK {
    constructor() {
        this.publicRegistry = new Map();
        this.walletRegistry = new Map();
    }
    registerHTLCPublicClient(chainNamespace, factory) {
        this.publicRegistry.set(chainNamespace, factory);
    }
    registerHTLCWalletClient(chainNamespace, factory) {
        this.walletRegistry.set(chainNamespace, factory);
    }
    createHTLCPublicClient(chainNamespace, config) {
        const factory = this.publicRegistry.get(chainNamespace);
        if (!factory) {
            throw new RegistrationError(`No HTLC public client registered for chain namespace: ${chainNamespace}. ` +
                `Did you forget to call the corresponding register function (e.g. registerEvmSdk())?`);
        }
        return factory(config);
    }
    createHTLCWalletClient(chainNamespace, config) {
        const factory = this.walletRegistry.get(chainNamespace);
        if (!factory) {
            throw new RegistrationError(`No HTLC wallet client registered for chain namespace: ${chainNamespace}. ` +
                `Did you forget to call the corresponding register function (e.g. registerEvmSdk())?`);
        }
        return factory(config);
    }
    getRegisteredNamespaces() {
        return Array.from(new Set([
            ...this.publicRegistry.keys(),
            ...this.walletRegistry.keys(),
        ]));
    }
}
// Default instance + free functions
export const defaultTrainSDK = new TrainSDK();
export function registerHTLCPublicClient(chainNamespace, factory) {
    return defaultTrainSDK.registerHTLCPublicClient(chainNamespace, factory);
}
export function registerHTLCWalletClient(chainNamespace, factory) {
    return defaultTrainSDK.registerHTLCWalletClient(chainNamespace, factory);
}
export function createHTLCPublicClient(chainNamespace, config) {
    return defaultTrainSDK.createHTLCPublicClient(chainNamespace, config);
}
export function createHTLCWalletClient(chainNamespace, config) {
    return defaultTrainSDK.createHTLCWalletClient(chainNamespace, config);
}
export function getRegisteredNamespaces() {
    return defaultTrainSDK.getRegisteredNamespaces();
}
